<div>
<div class="row" style="margin-top: 2%">
    <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
            <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #1</p>
        </span>
        <span class="download-temaplte">
            <a [href]='Filepath' download>
                Download Template
            </a>
        </span>
    </div>
    <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
            <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #2</p>
        </span>
        <span class="">
            Add your data (changes only) in the Template.
        </span>
    </div>
    <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xs-4">
        <span class="form-inline-new">
            <p class="merge-headers" style="color: #013b71;font-weight: bold;">Step #3</p>
        </span>
        <span class="">
            <input type="file" #fileInput id="uploadFile"
                (change)="uploadFileEvt($event.target.files)"
                name="uploadFile" accept=".xlsx" />
        </span>
    </div>
</div>
<div class="row" style="float:right; margin-top: 2%; margin-right:5%">
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
        <button [disabled]="disableSubmit" (click)="submit()"   mat-mdc-raised-button 
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs ">
                Submit
            </button>
    </div>
</div>
<div class="stk-table-loader bulk-loader" *ngIf="showLoader">
    <app-loader>
    </app-loader>
</div>
</div>

